import styled from 'styled-components';
import { breakpoint } from '@sketch/global-styles';
import { ReactComponent } from '@sketch/icons/calendar-16';
import { ReactComponent as ReactComponent$1 } from '@sketch/icons/pin-location-16';
import { Text, Link } from '@sketch/components';
import '../ResponsiveImage/index.js';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage.js';

const Calendar = styled(ReactComponent) `
  margin-right: 4px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  opacity: 55%;
  margin-bottom: 2px; /* stylelint-disable-line scales/space */
`;
const Pin = styled(ReactComponent$1) `
  margin-right: 4px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  opacity: 55%;
  margin-bottom: 2px; /* stylelint-disable-line scales/space */
`;
const ContentWrapper = styled.div `
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  flex: 1;

  ${breakpoint('base', 'lg') `
      padding: 16px 0;
  `}
`;
const ImageContainer = styled.div `
  margin-right: 40px;
  flex: 1;

  ${breakpoint('base', 'lg') `
      margin-right: 0;
  `}
`;
const StyledResponsiveImage = styled(ResponsiveImage) `
  border-radius: ${({ theme }) => theme.radii.xlarge};
  object-fit: cover;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.border.A};
`;
const Title = styled.h1 `
  margin: 0 0 4px 0;
  font-size: ${({ theme }) => theme.fontSizes.G};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  transition: color ${({ theme }) => theme.transitions.duration[1]};
`;
const Description = styled(Text).attrs({
    textStyle: 'copy.quaternary.standard.E',
}) `
  margin: 0;
`;
const ReadMore = styled.span `
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: currentColor;
  text-decoration: none;
  transition: color ${({ theme }) => theme.transitions.duration[1]};
`;
const Details = styled.div `
  display: flex;
  margin: 16px 0;
  font-size: ${({ theme }) => theme.fontSizes.E};
`;
const Date = styled.span `
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  white-space: nowrap;
`;
const Location = styled.span `
  display: flex;
  align-items: center;
  margin-left: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
const Speakers = styled.ul `
  display: flex;
  list-style: none;
  margin: 24px 0;
  padding: 0;
  flex-wrap: wrap;

  ${breakpoint('base', 'lg') `
    margin: 22px 0;
  `}
`;
const Speaker = styled.li `
  display: flex;
  align-items: center;
  flex: 1 1 50%;
  margin-top: 16px;
  line-height: 2; /* stylelint-disable-line scales/line-height */
  white-space: nowrap;
`;
const Photo = styled.img `
  width: 16px;
  height: 16px;
  border-radius: ${({ theme }) => theme.radii.rounded};
`;
const Name = styled.span `
  margin-left: 8px;
  font-size: ${({ theme }) => theme.fontSizes.D};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
const Role = styled(Text.Span).attrs({
    textStyle: 'copy.quaternary.standard.C',
}) `
  margin-left: 4px;
`;
const StyledLink = styled(Link) `
  display: flex;

  /* Reset all link styles */
  text-decoration: none;
  transition: none;
  white-space: pre-wrap;
  color: currentColor;

  &:hover {
    color: currentColor;

    ${Title} {
      color: ${({ theme }) => theme.colors.foreground.secondary.D};
    }

    ${ReadMore} {
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.foreground.secondary.D};
    }
  }

  ${breakpoint('base', 'lg') `
    flex-direction: column;
  `}
`;
const Time = styled.span `
  margin-left: 4px;

  ${breakpoint('base', 'md') `
    display: none;
  `}
`;

export { Calendar, ContentWrapper, Date, Description, Details, ImageContainer, Location, Name, Photo, Pin, ReadMore, Role, Speaker, Speakers, StyledLink, StyledResponsiveImage, Time, Title };
